<template>
  <div class="px-8">
    <div style="height: 105px;" class="d-flex align-center">
        <div
            @click="$router.push({ name: routeNames.MY_ACCOUNT })"
            class="circle d-flex justify-center align-center"
        >
            <v-icon
                size="30"
                color="#000230"
            >
                {{ "arrow_back" }}
            </v-icon>
        </div>
    </div>
    <p class="display-1" style="color: var(--primary-color-blue); font-size: 25px; font-weight: 700;">
      <v-icon size="24" class="pr-2 mb-2" color="#000230">person</v-icon>
      {{ $t("user.title") }}
    </p>
    <div v-if="!dataSaved">
      <div class="mt-5 mx-2 pb-12" v-if="userData.userData != null" style="max-height: 600px; overflow-y: auto;">
        <div v-if="!editing">
          <Input
            :inputTitle="$t('form.tag_id')"
            :disabled="true"
            key_index="tag_id"
          />
          <Input
            :inputTitle="$t('form.locator')"
            :disabled="true"
            key_index="locator"
          />
          <Input
            :inputTitle="$t('form.email')"
            :disabled="true"
            key_index="email"
          />
          <Input
            :inputTitle="$t('form.document')"
            :disabled="true"
            key_index="document"
          />
        </div>
        <Input
          :inputTitle="$t('form.name')"
          :disabled="!editable || !editing"
          key_index="name"
        />
        <Input
          :inputTitle="$t('form.surname')"
          :disabled="!editable || !editing"
          key_index="surname"
        />
        <Input
          :inputTitle="$t('form.phone_number')"
          :disabled="!editable || !editing"
          key_index="phoneNumber"
          type="number"
        />
        <Input
          :inputTitle="$t('form.birthdate')"
          :disabled="!editable || !editing"
          key_index="birthday"
          type="date"
        />
        <Input
          :inputTitle="$t('form.gender')"
          :disabled="!editable || !editing"
          key_index="gender"
          type="select"
        />
        <Input
          :inputTitle="$t('form.country')"
          :disabled="!editable || !editing"
          key_index="country"
        />
      </div>
      <div v-if="editable && !editing" class="btn-sticky">
        <v-btn
          fab
          style="background: var(--primary-color-blue);"
          elevation="0"
          class="textOverSecondary--text"
          @click="editData()"
        >
          <v-icon color="#fff"> edit </v-icon>
        </v-btn>
      </div>
      <div v-if="editing">
        <div
          @click="saveData()"
          class="mt-0 mb-3 px-5"
          :class="loading ? 'd-flex align-center justify-center' : ''"
          style="cursor: pointer; background: var(--primary-color-blue); border-radius: 16px; height: 65px;">
          <v-progress-circular
            v-if="loading"
            color="white"
            indeterminate
            class="d-flex"
          ></v-progress-circular>
          <p v-else="!loading" style="cursor: pointer; color: white; font-size: 16px; font-weight: 500; height: 65px; line-height: 65px; text-align: center;">
            {{ $t("user.save_changes") }}
          </p>
        </div>
        <p v-if="!loading" style="font-size: 16px; font-weight: 500; text-decoration: underline;" @click="editing = !editing" class="text-center">{{ $t('user.cancel') }}</p>
      </div>
    </div>
    <v-slide-x-transition hide-on-leave>
        <div
          v-if="dataSaved"
          class="d-flex flex-column align-center justify-center vertical-semi-centered"
        >
          <v-row
            class="section-title font-weight-bold d-flex align-center justify-center"
          >
            <v-icon style="font-size: 62px !important;" color="#34A853" class="big-icon my-6">
              {{ 'check_circle' }}
            </v-icon>
            <span
              style="font-size: 25px; font-weight: 700; line-height: 100%; text-align: center;"
              class="display w-100"
              >{{ $t('user.success_response.primary_text') }}</span>
            </v-row>
            <v-row class="pt-10 w-100">
              <v-btn
                style="background: var(--primary-color-blue); color: white; font-size: 16px; font-weight: 500;"
                class="semi-rounded my-8 mx-auto px-10 py-8 w-100"
                @click="dataSaved = !dataSaved">
                  {{ $t("actions.ok") }}
              </v-btn>
            </v-row>
        </div>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/views/layouts/MainLayout";
import RedirectHandler from "@/mixins/RedirectHandler";
import errorManager from "../services/error.manager";
import RequestMixin from "@/mixins/Requests";
import Input from "@/components/form-elements/InputCustom";
import { RequestService } from "../services/request.service";
const requestService = new RequestService();

export default {
  props: ["auth", "routeNames"],
  data() {
    return {
      editable: false,
      editing: false,
      loading: false,
      dataSaved: false
    };
  },
  components: {
    Layout,
    Input,
  },
  mixins: [RequestMixin, RedirectHandler],
  methods: {
    editData() {
      this.editing = true;
    },
    saveData() {
      this.loading = true;
      const context = this;
      requestService
        .editUserData(context, this.userData.editData)
        .then(async () => {
          await requestService.getUserData(context).then(() => {
            this.loading = false;
            this.$store.commit("resetEditData");
          });
          //this.successSaveData();
          this.editing = false;
          this.dataSaved = true;
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        });
    },
    successSaveData() {
      const action = "save-user-data";
      const viewData = {
        title: {
          vicon: "person",
          text: "user.title",
        },
        primary_text: {
          vicon: "check_circle",
          text: "user.success_response.primary_text",
        },
      };
      this.successRedirect(action, viewData);
    },
  },
  computed: {
    ...mapState(["userData"]),
  },
  beforeMount() {
    requestService.getUserData(this).then(() => {
      this.$store.commit("resetEditData");
    });
  },
  created() {
    this.getUserData();
    this.$store.dispatch("getEditProfile", this).then((editable) => {
      this.editable = editable;
    });
  },
  beforeDestroy() {
    requestService.getUserData(this).then(() => {
      this.$store.commit("resetEditData");
    });
  },
};
</script>
<style lang="css">
.circle {
  width: 52px !important;
  height: 52px !important;
  background-color: #0002300D !important;
  border-radius: 50% !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.btn-sticky {
  position: fixed;
  right: -50px;
  bottom: 75px;
  z-index: 1;
  width: 390px;
}
.display-1 i {
  font-size: 33px !important;
}
@media (min-width: 390px) {
  .btn-sticky {
    right: calc(50% - 220px);
  }
}
</style>
